import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'

function getAddonOrderItems(state: App.State, orderItems: App.OrderAddonItem[], order: App.Order) {
  if (!orderItems?.length) {
    return []
  }
  return orderItems?.reduce((items, orderItem) => {
    const orderConfirmationItem = comluxgroup.createItem_1_1_0(
      {
        offerId: orderItem.offerSalesforceId,
        categoryId: 'hotel',
        productId: 'addon',
        duration: 1,
        travelStart: orderItem.channelBookingStartTime,
        travelEnd: orderItem.channelBookingEndTime,
        price: orderItem.total,
        offerLeadDuration: '1',
        currency: order.currencyCode,
        destinationCity: orderItem.locationText,
        itemId: orderItem.id,
        bookingNumber: order.number,
        orderId: order.id,
      },
    )
    return [...items, orderConfirmationItem]
  }, [])
}

export default getAddonOrderItems
